import StatSummary from "@/components/common/Charts/StatSummary";
import styles from "../../../Statistik.module.scss";
import statistikkApi from "@/api/statistik";
import { mergeClassNames } from "@/util/index";
import { useQuery } from "@tanstack/react-query";

export default function Overblik() {
  const { data, isFetching } = useQuery<
    { id: number; navn: string; vaerdi: string }[]
  >({
    queryKey: ["overblik"],
    queryFn: async () => {
      const response = await statistikkApi.getOverblik();
      return response;
    },
  });
  return (
    <div
      className={mergeClassNames(
        styles.statcontainer,
        isFetching ? styles.loading : ""
      )}
    >
      <ul className={styles.overblik}>
        {isFetching && (
          <div style={{ opacity: 0 }}>
            <StatSummary title={"Loading"} value={0} />
          </div>
        )}
        {!isFetching && data && (
          <>
            {data.map((overblik) => {
              return (
                <StatSummary
                  key={overblik.id}
                  title={overblik.navn}
                  value={parseInt(overblik.vaerdi)}
                />
              );
            })}
          </>
        )}
      </ul>
    </div>
  );
}
